export default {
  props: {
    isAsideOpen: {
      type: Boolean,
      default: false,
    },

    gettingStartedPanelItemType: String,

    itemType: String,

    selectedModelId: {
      default: '',
      type: String,
    },

    setSelectedModelId: {
      default: () => {},
      type: Function,
    },

    viewport: {
      default: null,
      type: Object,
    },
  },

  methods: {
    showTooltip(bool) {
      if (this.viewport && this.viewport.tooltipProps) {
        this.viewport.tooltipProps.showTooltip = bool;
      }
    },
  },
};
